import React from 'react';
import { useLocationsData } from 'wsm-lsp-utilities';
import FilterItemList from '../components/FilterItemList';
import FilterModal from '../components/FilterModal';

const Widget = () => {
	const { isReady, error } = useLocationsData();
	if (error) {
		return null;
	}

	return (
		<React.Fragment>
			<div className="d-none d-md-flex">
				<FilterItemList />
			</div>
			<FilterModal isReady={isReady} />
		</React.Fragment>
	);
};

export default Widget;
